var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaja(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M105.2 172.2a7.8 7.8 0 1 0 15.6 0a7.8 7.8 0 1 0 -15.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M145.4 172.2a7.8 7.8 0 1 0 15.6 0a7.8 7.8 0 1 0 -15.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M161.3,103l-72.9,0l9.1,54.4h68.7l11.2-50.9H188V90.1h-23.9L161.3,103z M152.9,141h-41.5l-3.6-21.5l49.8,0L152.9,141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M246,39.5H10v177h236V39.5z M26.5,56h34.2v144H26.5V56z M77.1,56H200v144H77.1V56z M229.5,200h-13.1V56h13.1V200z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M34.5 130.6a8.6 8.6 0 1 0 17.2 0a8.6 8.6 0 1 0 -17.2 0z"
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null)))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaja);
export default __webpack_public_path__ + "static/media/caja.94f9ae708b8cedc1490b69a850d97038.svg";
export { ForwardRef as ReactComponent };